import { useList, useGetIdentity } from "@refinedev/core";

export const useServicePurchase = (featureId?: string) => {
  const { data: identity } = useGetIdentity<{ uid: string }>();

  // First get the database user ID from Firebase UID
  const { data: userData, isLoading: userLoading } = useList({
    resource: "auth_users",
    filters: [{ field: "uid", operator: "eq", value: identity?.uid }],
    pagination: { current: 1, pageSize: 1 },
    meta: { fields: ["id"] },
    queryOptions: {
      enabled: !!identity?.uid
    }
  });

  const dbUserId = userData?.data?.[0]?.id;

  const { data: servicePurchases, isLoading: purchaseLoading } = useList({
    resource: "service_purchase",
    filters: [
      { field: "user_id", operator: "eq", value: dbUserId },
      { field: "feature_id", operator: "eq", value: featureId },
      { field: "status", operator: "eq", value: "active" }
    ],
    pagination: { current: 1, pageSize: 1 },
    meta: {
      fields: ["id", "status", "created_at"]
    },
    queryOptions: {
      enabled: !!dbUserId && !!featureId
    }
  });

  const hasPurchased = servicePurchases?.data && servicePurchases.data.length > 0;

  return {
    hasPurchased,
    isLoading: userLoading || purchaseLoading,
    servicePurchase: servicePurchases?.data?.[0]
  };
};